var exports = {
  "k": "xae11d333--77d1bd--container",
};

module.exports = exports;
